<template>
    <section>
      <transition name="fade">
        <div class="bloco-animacao-redirecionar-usuario" v-if="animacao">
          <h1><BreedingRhombusSpinner/></h1>
        </div>
      </transition>
    </section>
</template>

<script>
import { BreedingRhombusSpinner } from 'epic-spinners'

export default {
  data () {
    return {
      grupoRedirect: [
        {grupo: 'nomeDeGrupoDeExemplo', rota: './nomeDaRotaExemplo'},
        {grupo: 'cgs', rota: './meusChamadosCgs'}
      ],
      rotaDefault: '/MeusChamados',
      animacao: true
    }
  },
  mounted: function () {
    let rotaGrupo = this.grupoRedirect.filter(item => item.grupo === this.$store.state.login.loginUsuario.grupo.nome)
    let vm = this
    setTimeout(() => {
      (rotaGrupo.length && vm.$route.fullPath === '/') ? this.$router.push({path: rotaGrupo[0].rota}) : this.$router.push({path: vm.$route.fullPath})
      vm.animacao = false
    }, 2000)
  },
  components: {
    BreedingRhombusSpinner
  },
  methods: {
    redirecionarUsuarioAposLogin: function () {
      return 'isso é um teste'
    }
  }
}
</script>

<style scoped>
  .bloco-animacao-redirecionar-usuario {
    color: #FFF;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #222d32;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 1s;
    text-align: center;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?519dc6ac